import * as React   from "react";
import {cs}         from "@Common/react/chain-services";
import {UseState}   from "@Common/react/use-state";
import {Form}       from "../../../../demographics/step-2-customize/form/form";
import {last}       from "../../../../../../../../../utils/collections";

import "./demographics-section.scss"
import {config, configKeys} from "../../../../common/demographics-config";

export const DemographicsSection = ({next: rootNext}) => cs(
    ["customization", (_, next) => UseState({
        initValue: undefined,
        next: (s) => next({
            ...s,
            value: {
                ...getDefaultInputsCustomizations(config),
                ...s.value,
            },
        }),
    })],
    ["form", ({customization}, next) => Form({
        config,
        state: customization,
        next,
    })],
    ({customization, form}) => rootNext({
        valid: !form.invalid,
        highlightErrors: form.highlightErrors,
        demographics: {
            ...customization.value,
            ...configKeys,
        },

        render: ({showErrors}) => (
            <div className="demographics-section-5gx">
                <div className="header">
                    <div 
                        className="title"
                        xd-qa-type="label"
                        xd-qa-name="Neighborhood Search Add a Neighborhood Match Score"
                    >
                        Add a Neighborhood Match Score
                    </div>
                    <div 
                        className="sub-title"
                        xd-qa-type="label"
                        xd-qa-name="Neighborhood Search Add a Neighborhood Match Score Description"
                    >
                        Define key demographics and we will provide a match rate score for your targeted neighborhoods.
                        Your order will be mailed to the entire route to maximize reach.
                    </div>
                </div>

                <div className="box search">
                    {form.render({
                        showErrors,
                    })}
                    <div className="clear">
                        <a {...{
                            onClick: () => customization.change(() => ({...getDefaultInputsCustomizations(config)})),
                            "xd-qa-type": "link",
                            "xd-qa-name": "Neighborhood Search Reset Demographics"
                        }}>
                            Reset Demographics
                        </a>
                    </div>
                </div>
            </div>
        )
    })
);

const getDefaultInputsCustomizations = (config) => {
    return Object.keys(config).reduce((v, key) => {
        const fieldConfig = config[key];
        if (fieldConfig.targetType === "rangeType") {
            return {
                ...v,
                [key + "_low" ]: "" + fieldConfig.values.low[0],
                [key + "_high"]: "" + last(fieldConfig.values.high),
            };
        }
        if (fieldConfig.targetType === "checkboxType") {
            return {
                ...v,
                ...Object.keys(fieldConfig.values).reduce((f, field) => ({
                    ...f,
                    [key + "_" + fieldConfig.values[field]]: false
                }), {})
            }
        }
        return v;
    }, {});
};